import {LitElement, html} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import {style} from './ch-article-info.styles';

@customElement('sbk-ch-article-info')
export class Banner extends LitElement {

    @property({type: String})
    date = ''

    @property({attribute: 'reading-time'})
    readingTime = ''

    static get styles() {
        return style;
    }

    render() {
        if (this.readingTime) {
            return html`
                <div class="article-info">
                    <span>${this.date}</span>
                    <span class="article-info__reading-time">${this.readingTime}</span>
                </div>
            `
        } else {
            return html`
                <div class="article-info">
                    <span>${this.date}</span>
                </div>
            `
        }
    }
}
